import React from 'react';
import styled from '@emotion/styled';
import { useRecoilValue } from 'recoil';
import { accountState } from 'state/atoms';

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: normal;
  margin: 0 0 1.43rem;
`;

const Subtitle = styled.h2`
  font-size: 1.75rem;
  font-weight: bolder;
  margin-bottom: 1.43rem;
  margin-top: 0;
  line-height: 150%;
`;

const Account = styled.h3`
  font-size: 1.5rem;
  line-height: 150%;
  margin-bottom: 1.43rem;
  color: ${({ theme }) => theme.colors.primary};
  text-transform: uppercase;
`;

const Currency = styled.h4`
  font-size: 1.25rem;
  text-transform: uppercase;
  line-height: 150%;
  color: ${({ theme }) => theme.colors.primary};
`;

const AccountInformation = ({ fullName, account }) => {
  const { defaultCurrencyCode } = useRecoilValue(accountState);
  return (
    <>
      <Title>RMA Manager</Title>
      <Subtitle>Welcome {fullName}</Subtitle>
      <Account>{account}</Account>
      <Currency>Account Currency: {defaultCurrencyCode}</Currency>
    </>
  );
};

export { AccountInformation };
